import Colors from 'components/Colors.js';
import {WIDTH, HEIGHT} from '../constants.js';

const colors = new Colors();
export const drawMacros = (gl, program, macros) => {
    // look up where the vertex data needs to go.
    var positionAttributeLocation = gl.getAttribLocation(program, "a_position");
    // look up uniform locations
    var colorUniformLocation = gl.getUniformLocation(program, "u_color");
    
    // Tell it to use our program (pair of shaders)
    gl.useProgram(program);

    // code above this line is initialization code
    // --------------------------------
    // code below this line is rendering code

    // Turn on the attribute
    var positionBuffer = gl.createBuffer();
    gl.enableVertexAttribArray(positionAttributeLocation);


    for (let macro of macros) {
        gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
        let points = getMacro(gl, macro);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(
            points
        ), gl.STATIC_DRAW);
        // Set a random color.
        
        gl.vertexAttribPointer(
            positionAttributeLocation, 2, gl.FLOAT, false, 0, 0);
        let {r,g,b} = colors.getRGB(macro.color);
        gl.uniform4f(colorUniformLocation, r/255.0, g/255.0, b/255.0, 1);
        gl.drawArrays(gl.TRIANGLES, 0, points.length/2);
    }
};

// Fill the buffer with the values that define a rectangle.
function getMacro(gl, macro) {
    let blobPoints = macro.getBlob2();
    let list = [];
    let i=0;
    for (let pt of blobPoints) {
        list = [
            ...list,
            -1 + 2*(pt.x/WIDTH),
            -1 + 2*(1 - pt.y/HEIGHT),
        ];
        if (i > 2 && i % 3 == 2) {
            list = [... list, ...list.slice(0,2)];
        }
        i++;
    }
    return list;
}

